import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { parseHTML } from '../../utils/parseHMTL';

interface IHelmet {
  companyName?: string;
  clientLogoURL?: string;
  primaryColor?: string;
  secondaryColor?: string;
  playerName?: string;
  actionTitle?: string;
  actionImages?: { url?: string }[];
  tabTitle?: string;
  clientFavicon?: string;
  googleAnalyticsIntegration?: boolean | string | undefined;
  pixelIntegration?: boolean | string | undefined;
}

export function HelmetComponent({
  companyName,
  clientLogoURL,
  primaryColor,
  secondaryColor,
  playerName,
  actionTitle,
  actionImages,
  clientFavicon,
  tabTitle,
  googleAnalyticsIntegration,
  pixelIntegration,
}: IHelmet) {
  const colors = {
    primaryColor: primaryColor ? primaryColor : '#000000',
    secondaryColor: secondaryColor ? secondaryColor : '#ffffff',
  };

  useEffect(() => {
    if (pixelIntegration) {
      pixelSequenceInject();
    }
  }, []);

  function pixelSequenceInject() {
    const noScriptTag = parseHTML(`${pixelIntegration}`).children[1];
    noScriptTag.setAttribute('id', 'pixel-noscript');

    const imageTagTracking = parseHTML(
      `${pixelIntegration}`
    ).children[1].innerHTML.toString();
    noScriptTag.textContent = imageTagTracking;

    const simpleScript = parseHTML(`${pixelIntegration}`).children[0];
    simpleScript.setAttribute('id', 'pixel-script');

    // script comum
    if (!document.querySelector('#pixel-script')) {
      document.getElementsByTagName('head')[0].appendChild(simpleScript);
    }
    // fim script comum

    // noscript tag
    if (!document.querySelector('#pixel-noscript')) {
      document.getElementsByTagName('head')[0].appendChild(noScriptTag);
    }
    // fim noscript tag
  }

  return (
    <>
      <Helmet>
        {/* Google Analytics Integration */}
        {googleAnalyticsIntegration && (
          <>
            <script
              async
              src={
                parseHTML(`${googleAnalyticsIntegration}`) &&
                parseHTML(`${googleAnalyticsIntegration}`).children[0]
                  ? parseHTML(`${googleAnalyticsIntegration}`).children[0]
                      .attributes.src.value
                  : ''
              }
            ></script>
            <script>
              {parseHTML(`${googleAnalyticsIntegration}`) &&
              parseHTML(`${googleAnalyticsIntegration}`).children[1]
                ? parseHTML(`${googleAnalyticsIntegration}`).children[1]
                    .innerHTML
                : ''}
            </script>
          </>
        )}
        {/* End Google Analytics Integration */}
        <title>
          {companyName ? `${companyName} - ${tabTitle}` : 'OQ Digital'}
        </title>
        <meta name="robots" content="noindex" />
        <link rel="icon" type="image/x-icon" href={clientFavicon} />
        <meta property="og:site_name" content="OQ Digital" />
        <meta name="og:description" content={tabTitle} />
        <meta property="og:title" content={`${tabTitle}`} />
        <meta
          property="og:image"
          itemProp="image"
          content={
            actionImages && actionImages[0]
              ? actionImages[0].url
              : clientLogoURL
          }
        />
        <meta
          property="og:image:secure_url"
          content={
            actionImages && actionImages[0]
              ? actionImages[0].url
              : clientLogoURL
          }
        />
        {playerName && actionTitle && (
          <meta
            property="og:description"
            content={`${playerName} tem um convite para você!`}
          />
        )}
        <meta property="og:type" content="website" />
        <meta property="og:image:width" content="200" />
        <meta property="og:image:height" content="200" />
        <style type="text/css">
          {`
        :root {
          --primary-color: ${colors.primaryColor};
          --secondary-color: ${colors.secondaryColor};
        }   
        `}
        </style>
      </Helmet>
    </>
  );
}
